module.exports = __webpack_public_path__ + "img/cart-dash.0d822214.svg";